import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react'

interface SmartLayerEditMaskContextValue {
  excludedMamIds: Set<string>
  setExcludedMamIds: (ids: Set<string>) => void
}

const SmartLayerEditMaskContext =
  createContext<SmartLayerEditMaskContextValue | null>(null)

export const SmartLayerEditMaskProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [excludedMamIds, setExcludedMamIdsState] = useState<Set<string>>(
    () => new Set()
  )

  const setExcludedMamIds = useCallback((ids: Set<string>) => {
    setExcludedMamIdsState(ids)
  }, [])

  const value = useMemo(
    () => ({ excludedMamIds, setExcludedMamIds }),
    [excludedMamIds, setExcludedMamIds]
  )

  return (
    <SmartLayerEditMaskContext.Provider value={value}>
      {children}
    </SmartLayerEditMaskContext.Provider>
  )
}

export const useSmartLayerEditMask = (): SmartLayerEditMaskContextValue => {
  const ctx = useContext(SmartLayerEditMaskContext)
  if (!ctx) {
    throw new Error(
      'useSmartLayerEditMask must be used within SmartLayerEditMaskProvider'
    )
  }
  return ctx
}

/** Safe when provider is absent (e.g. tests). */
export const useSmartLayerEditMaskOptional =
  (): SmartLayerEditMaskContextValue | null =>
    useContext(SmartLayerEditMaskContext)
